<template>
  <div class="main">
    <Nav />
=    <div class="resourceList container">
      <div class="columns">
        <div class="column">
          <div class="level">
            <div class="level-left">
              <h1 class="title">{{ resource.title }}</h1>
            </div>
          </div>
          <p>{{ resource.annotation }}</p>
          <hr />
          <iframe
            width="560"
            height="315"
            :src="'https://www.youtube.com/embed/' + resource.videoId"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <hr />
          <router-link
            class="button is-primary"
            :to="{ name: 'resources', params: { parameters: this.listProps } }"
            v-if="fromList"
          >
            <span class="icon">
              <i class="fas fa-angle-double-left"></i>
            </span>
            <span>Back to List</span>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  name: "resource",
  data() {
    return {
      resource: null,
      serial: 0
    };
  },
  props: ["listProps", "fromList"],
  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData: function() {
      console.log("fetching data");
      const url = `${process.env.VUE_APP_API_URL}resource/${this.$route.params.id}`;
      console.log(url);
      axios.get(url).then(response => {
        console.log(url);
        this.resource = response.data.resource;
      });
    }
  },

  components: {
    Nav,
    Footer
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.resourceList{
  margin-top:2rem;
}
h1.title {
  font-size: 3rem;
}

.box {
  height: 100%;
}

.timepicker {
  margin-top: 10px;
}
</style>
